<template>
    <ModalConfirm
        id="modal-confirm-ca-kas-kecil"
        title="Konfirmasi Setujui CA"
        :desc="desc"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-ca-approval",
    props: {
        desc: { type: String, default: "" },
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
